// components/common/chute-dropdown.tsx
import { useEffect } from 'react';

import { Dropdown } from 'primereact/dropdown';
import { useSearchParams } from 'react-router-dom';

type Option = { label: string; value: string };

const OPTIONS: Option[] = [
  { label: 'Chute 1', value: '1' },
  { label: 'Chute 2', value: '2' },
];

type Props = {
  value?: string | null;
  disabled?: boolean;
  paramKey?: string;
  className?: string;
  onChange?: (v: string | null) => void;
};

export default function ChuteDropdown({
  value = null,
  disabled,
  paramKey = 'chuteNumber',
  className,
  onChange,
}: Props) {
  const [sp, setSp] = useSearchParams();

  useEffect(() => {
    if (value !== null) return;
    const urlVal = sp.get(paramKey);
    if (urlVal) onChange?.(urlVal);
  }, [value, sp, paramKey, onChange]);

  const write = (v: string | null) => {
    const next = new URLSearchParams(sp);
    if (v && v !== '1') {
      next.set(paramKey, v);
    } else {
      next.delete(paramKey);
    }
    setSp(next, { replace: true });
    onChange?.(v);
  };

  const selectedValue = value ?? '1';

  return (
    <Dropdown
      value={selectedValue}
      options={OPTIONS}
      optionLabel="label"
      optionValue="value"
      disabled={disabled}
      className={className}
      onChange={(e) => write(e.value ?? null)}
    />
  );
}
